export const BROWSE_USER = 1;
export const EDIT_USER = 2;
export const GX_ADMIN = 3;

// ログインユーザー種別
export const FROM_GPP = 1;
export const FROM_MONI = 2;

// ログイン画面
export const LoginConstants = {
  Title: "充電サービス管理画面ログイン",
  LoginId: "ログインID",
  Password: "パスワード",
  Otp: "ワンタイムパスワード",
  Button: "ログイン",
} as const;

export type LoginModel = {
  id: string;
  password: string;
};

export type ResponseLogin = {
  token: string;
  type: typeof FROM_GPP | typeof FROM_MONI;
};

export type LoginModelErrorType = {
  id?: boolean;
  password?: boolean;
};

export const CookieKey = {
  operator: "operator",
  gxoperator: "gxoperator",
} as const;

// ユーザー情報
export type UserInfo = {
  id?: number;
  name?: string;
  auth?: RolePattern;
  role?: typeof BROWSE_USER | typeof EDIT_USER | typeof GX_ADMIN;
};

export type RolePattern = {
  Dashboard: boolean;
  Cars: boolean;
  CarsDetail: boolean;
  CarsEdit: boolean;
  ChargerExclude: boolean;
  ChargerExcludeCreate: boolean;
  ChargerExcludeDetail: boolean;
  ChargerExcludeEdit: boolean;
  DriverWorkShift: boolean;
  DriverWorkShiftEdit: boolean;
  DriverWorkShiftCreate: boolean;
  DriverWorkCycleEdit: boolean;
  DriverWorkCycleCreate: boolean;
  DriverWorkCycles: boolean;
  DriverWorkCycleDetails: boolean;
  OperationPlans: boolean;
  OperationPlansEdit: boolean;
  ChargePlans: boolean;
  ChargerUsageStatus: boolean;
  ContractFee: boolean;
  ChargeSupplyDays: boolean;
  ChargeSupplyTransactions: boolean;
  PartnerUsers: boolean;
  PartnerUserEdit: boolean;
  IncidentReport: boolean;
  SettingFileUpload: boolean;
  CarNoopEvents: boolean;
  CarNoopEventsEdit: boolean;
  CarNoopReasonedEvents: boolean;
  CarUnderuseEvents: boolean;
  CarUnderuseEventsEdit: boolean;
  CarUnderuseAnswers: boolean;
  ELearning: boolean;
  QuickChargerRemainingTime: boolean;
  ManualDownload: boolean;
  DriverGuideDownload: boolean;
  RevenueSimulations: boolean;
  BillingPaymentSchedule: boolean;
};

// 画面権限APIリターンのkey値
export const DisplayName = {
  Dashboard: "Dashboard",
  Cars: "Cars",
  CarsDetail: "CarsDetail",
  CarsEdit: "CarsEdit",
  ChargerExclude: "ChargerExclude",
  ChargerExcludeCreate: "ChargerExcludeCreate",
  ChargerExcludeDetail: "ChargerExcludeDetail",
  ChargerExcludeEdit: "ChargerExcludeEdit",
  DriverWorkCycles: "DriverWorkCycles",
  DriverWorkCycleDetails: "DriverWorkCycleDetails",
  DriverWorkShift: "DriverWorkShift",
  DriverWorkShiftEdit: "DriverWorkShiftEdit",
  DriverWorkShiftCreate: "DriverWorkShiftCreate",
  DriverWorkCycleEdit: "DriverWorkCycleEdit",
  DriverWorkCycleCreate: "DriverWorkCycleCreate",
  OperationPlans: "OperationPlans",
  OperationPlansEdit: "OperationPlansEdit",
  ChargePlans: "ChargePlans",
  ChargerUsageStatus: "ChargerUsageStatus",
  ContractFee: "ContractFee",
  ChargeSupplyDays: "ChargeSupplyDays",
  ChargeSupplyTransactions: "ChargeSupplyTransactions",
  PartnerUsers: "PartnerUsers",
  PartnerUserEdit: "PartnerUserEdit",
  IncidentReport: "IncidentReport",
  SettingFileUpload: "SettingFileUpload",
  CarNoopEvents: "CarNoopEvents",
  CarNoopEventsEdit: "CarNoopEventsEdit",
  CarNoopReasonedEvents: "CarNoopReasonedEvents",
  CarUnderuseEvents: "CarUnderuseEvents",
  CarUnderuseEventsEdit: "CarUnderuseEventsEdit",
  CarUnderuseAnswers: "CarUnderuseAnswers",
  ELearning: "ELearning",
  QuickChargerRemainingTime: "QuickChargerRemainingTime",
  ManualDownload: "ManualDownload",
  DriverGuideDownload: "DriverGuideDownload",
  RevenueSimulations: "RevenueSimulations",
  BillingPaymentSchedule: "BillingPaymentSchedule",
} as const;

export type DisplayKey = (typeof DisplayName)[keyof typeof DisplayName];

export const AuthError = {
  NOT_AUTHORITY: {
    message: "当該ユーザーにはアクセス権限がありません。",
    redirect: false,
  },
} as const;
